export default "__VITE_PUBLIC_ASSET__57c22ef7__"